// ============================================================================
// GeoMessagePreview.tsx — ЛОКАЛЬНОЕ превью геометки в сообщении чата.
//
// ОГРАНИЧЕНИЕ (честно): серверный тип сообщения «geo» не поддержан — геометка
// едет обычным текстом (канонический формат, lib/geo/geoMessage.ts), а карта
// рисуется НА КЛИЕНТЕ. Клик по превью открывает карту целиком.
// ============================================================================

import { useState } from 'react';
import { MapPin } from 'lucide-react';
import { UniversalWindow } from '@/components/ui/UniversalWindow';
import { formatGeoMessage, type GeoMessagePoint } from '@/lib/geo/geoMessage';
import { MapView, type GeoMarker } from './MapView';

interface GeoMessagePreviewProps {
  point: GeoMessagePoint;
  mine?: boolean;
}

export function GeoMessagePreview({ point, mine }: GeoMessagePreviewProps) {
  const [open, setOpen] = useState(false);
  const marker: GeoMarker[] = [{ id: '__geo', lat: point.lat, lon: point.lon, label: point.label || 'Геометка', kind: 'point' }];
  const caption = point.label
    ? `${point.label} · ${point.lat.toFixed(5)}, ${point.lon.toFixed(5)}`
    : `${point.lat.toFixed(5)}, ${point.lon.toFixed(5)}`;

  return (
    <>
      <button
        type="button"
        className={`mt-1.5 w-full max-w-[280px] text-left rounded-xl border overflow-hidden ${mine ? 'border-primary/30' : 'border-border'} hover:opacity-95`}
        onClick={() => setOpen(true)}
        title="Открыть карту"
      >
        <MapView markers={marker} height={132} interactive={false} showLocate={false} showNavigation={false} />
        <span className="flex items-center gap-1.5 px-2 py-1 text-[11px] text-muted-foreground">
          <MapPin className="h-3 w-3 shrink-0" />
          <span className="truncate">{caption}</span>
        </span>
      </button>

      {open && (
        <UniversalWindow open onClose={() => setOpen(false)} title={point.label || 'Геометка'} blocking width="max-w-2xl" resizable={false}>
          <div className="p-2 space-y-2">
            <MapView markers={marker} height={420} initialZoom={15} initialCenter={{ lat: point.lat, lon: point.lon }} />
            <div className="text-[11px] text-muted-foreground font-mono">
              {point.lat.toFixed(6)}, {point.lon.toFixed(6)}
            </div>
            <div className="text-[11px] text-muted-foreground">
              Текст сообщения: {formatGeoMessage(point)}
            </div>
          </div>
        </UniversalWindow>
      )}
    </>
  );
}
